/**
 * The delivery-job printout's cut lines — the four rules that CANNOT be
 * inline styles, transcribed from the retired `packagingToHtml` stylesheet
 * (`git show cabdcf32^:backend/src/contexts/delivery/domain/packaging-format.ts`).
 *
 * Everything else about the card and the grid is an inline style on the
 * element that owns it. These four are not, and each for a specific reason:
 *
 *  - `.sheet-grid::before` is a pseudo-element. There is no element to put an
 *    inline style on.
 *  - `.card:nth-last-child(-n + 2)` is positional: the bottom row of a sheet
 *    draws no rule, because a line there is a cut through the page edge. An
 *    inline `background-image` on every card would also WIN over this rule,
 *    so the base line has to be a class rule too.
 *  - `break-inside` rides along with them, in the same rule, so the card's
 *    print behaviour reads in one place.
 *
 * The cut lines are what makes a borderless card legible: the operator cuts
 * ten cards out of one sheet by hand, so every printed line is a line to cut
 * along. That is why the card itself has no border (#1902) — a decorative
 * border and a cut guide are indistinguishable with scissors in hand.
 *
 * `PackagingSheet` renders this as a `<style>` inside its own subtree, which
 * is what makes the sheet self-contained: the print window's document links
 * none of the app's CSS.
 */

/**
 * 103.5mm = one 101mm card + half the 5mm gutter — the middle of the space
 * between the two columns, not a card edge.
 */
export const PACKAGING_SHEET_CSS = `
.sheet-grid::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 103.5mm;
  border-left: 0.2mm dashed #777;
  pointer-events: none;
}
.card {
  break-inside: avoid;
  background-image: repeating-linear-gradient(
    to right,
    #777 0,
    #777 1.5mm,
    transparent 1.5mm,
    transparent 3mm
  );
  background-size: 3mm 0.2mm;
  background-position: left bottom;
  background-repeat: repeat-x;
}
.card:nth-last-child(-n + 2) { background-image: none; }
@media screen {
  .sheet-grid + .sheet-grid { margin-top: 10mm; }
}
`;
